import { render, staticRenderFns } from "./Skirmishes.vue?vue&type=template&id=04514f2d&"
import script from "./Skirmishes.vue?vue&type=script&lang=js&"
export * from "./Skirmishes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports